<template>
  <div @keyup.enter.prevent="submit">
    <div class="title"> SMS-подтверждение </div>

    <div class="text-margin">
      <div class="text text-margin">
        На ваш мобильный телефон выслано SMS-сообщение с кодом подтверждения.
      </div>
      <div v-if="session" class="text">
        Сессия: <span class="text-bold"> {{ session }} </span>
      </div>
    </div>

    <form-group :validator="$v.form.code" :server-errors="serverError('code')">
      <template slot-scope="{ attributes }">
        <UiInputText
          ref="code"
          v-model.number="form.code"
          placeholder="Код подтверждения"
          type="number"
          :class="attributes.class"
          @input="reset($v.form.code, 'code')"
        >
        </UiInputText>
      </template>
    </form-group>

    <div>
      <span
        :class="['like-a', { 'like-a_disabled': timer.value > 0 || trySubmit }]"
        @click="resendSmsCode"
      >
        Выслать код повторно
      </span>
      <span v-if="timer.value > 0" class="text">({{ formattedTimer }})</span>
    </div>

    <div class="footer">
      <UiButton
        :disabled="trySubmit"
        :class="['button', 'is-blue', { 'is-loading': trySubmit }]"
        @click="submit"
      >
        Подтвердить
      </UiButton>
    </div>
  </div>
</template>

<script>
import UiInputText from '@/components/UiInputText.vue'
import UiButton from '@/components/UiButton.vue'

import { required, minLength } from 'vuelidate/lib/validators'
import validationHelpers from '@/mixins/validationHelpers.js'
import countdownTimer from '@/mixins/countdownTimer.js'

import { AuthService } from '@/services/auth.service'

import { firstAvailable } from '@/router/util'

export default {
  components: {
    UiInputText,
    UiButton,
  },
  mixins: [countdownTimer, validationHelpers],
  props: {
    twoFaResponse: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      timerCount: 90,
      tryCodeSent: false,
      trySubmit: false,
      form: {
        code: '',
      },
    }
  },
  computed: {
    formattedTimer() {
      if (!this.timer.value) return

      return `${this.hms.m}:${this.hms.s}`
    },
    session() {
      return this.twoFaResponse && this.twoFaResponse.session
    },
  },
  validations: {
    form: {
      code: {
        required,
        minLength: minLength(6),
      },
    },
  },
  mounted() {
    this.countdownTimer().restart()

    this.focusCodeInput()
  },
  methods: {
    focusCodeInput() {
      const input = document.querySelector('input')

      input.focus()
    },
    async submit() {
      this.$v.$touch()
      this.clearFormServerErrors()

      if (this.$v.$invalid) return

      try {
        this.trySubmit = true

        await AuthService.loginCheckCode({
          code: this.form.code,
          session: this.session,
        })

        await this.$store.dispatch('user/getCurrent')

        await this.$router.push(this.$route.query.redirectFrom || { name: firstAvailable() })
      } catch (error) {
        this.trySubmit = false
        this.formServerErrors = error.formServerErrors

        if (error.status !== 422) {
          this.$store.commit('toast/NEW', { type: 'error', message: error.message })
        }
      } finally {
        this.trySubmit = false
      }
    },

    /**
     * Resend sms code.
     * Run method `AuthService.makeLogin` for resend sms code.
     *
     * this.$emit('continue-2fa') updated props object `this.twoFaResponse`
     */
    async resendSmsCode() {
      try {
        this.tryCodeSent = true

        const { email, password } = this.twoFaResponse
        const response = await AuthService.makeLogin({ email, password })

        /**
         * Merge props object `this.twoFaResponse`.
         * Get unchanged email and password. Refresh session token by response.
         */
        this.$emit('continue-2fa', {
          ...this.twoFaResponse,
          ...response.data,
        })

        this.countdownTimer().restart()
      } catch (error) {
        this.$store.commit('toast/NEW', { type: 'error', message: error.message })
      } finally {
        this.tryCodeSent = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.text {
  color: $color-gray-300;

  &-margin {
    margin: 0 0 rem(16px) 0;
  }

  &-bold {
    font-weight: bold;
  }
}

.footer {
  margin: rem(20px) 0 0 0;
}
</style>
